const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  "6LdhiMIsAAAAAAzVmbNx72iDisSiy1XL48B2FMfr";

let recaptchaLoadPromise;

function loadRecaptchaScript() {
  if (window.grecaptcha) {
    return Promise.resolve(window.grecaptcha);
  }

  if (recaptchaLoadPromise) {
    return recaptchaLoadPromise;
  }

  recaptchaLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById("google-recaptcha-v3");

    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(window.grecaptcha));
      existingScript.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.id = "google-recaptcha-v3";
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.grecaptcha);
    script.onerror = reject;

    document.head.appendChild(script);
  });

  return recaptchaLoadPromise;
}

export async function executeRecaptcha(action) {
  if (!RECAPTCHA_SITE_KEY) {
    throw new Error("Missing reCAPTCHA site key");
  }

  const grecaptcha = await loadRecaptchaScript();

  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      grecaptcha
        .execute(RECAPTCHA_SITE_KEY, { action })
        .then(resolve)
        .catch(reject);
    });
  });
}
